<div class="ws-screen-body">
  <div class="change-customer" [ngStyle]="dataService.windowInnerHeight$() | async">
    <div class="change-customer__title">Change Customer</div>
    <div class="zgridmenu">
      <!-- MENU -->
      <div class="zgridmenu--nogrow">
        <div
          class="zgridmenu__def"
          [class.zgridmenu__def--menu]="(authService.changeCustomerShowing | async) === 'grid'"
          [class.zgridmenu__grid--show]="showGrid"
        >
          <app-grid-menu [menuList]="menuList" [helpList]="helpList"></app-grid-menu>
        </div>
      </div>

      <!-- FITLER SCREEN -->
      <div class="zgridmenu--nogrow">
        <div class="zgridmenu__def" [class.zgridmenu__def--filter]="(authService.changeCustomerShowing | async) === 'filter'">
          <app-change-customer-filter></app-change-customer-filter>
        </div>
      </div>

      <!-- HELP SCREEN -->
      <div class="zgridmenu--nogrow">
        <div class="zgridmenu__def" [class.zgridmenu__def--help]="(authService.changeCustomerShowing | async) === 'help'">
          <app-grid-help [goBack]="showMain" [helpList]="helpList"></app-grid-help>
        </div>
      </div>

      <div class="zgridmenu--grow">
        <div class="zgridmenu__grid" [class.zgridmenu__grid--show]="showGrid">
          <app-change-customer-grid></app-change-customer-grid>
        </div>
      </div>
    </div>
  </div>
</div>
